module.exports = __webpack_public_path__ + "static/img/09.ac895af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20240801/09.png
// module id = P0ap
// module chunks = 0